export class PerformanceMonitorStorageSerializer {
    serializeForStorage(data) {
        return JSON.stringify(data);
    }
    deserializeFromStorage(data) {
        try {
            const value = JSON.parse(data);
            this.assertValid(value);
            return value;
        }
        catch (error) {
            return null;
        }
    }
    assertValid(data) {
        if (typeof data !== "object" ||
            data === null ||
            !("date" in data) ||
            !("enabled" in data)) {
            throw new Error("Invalid PerformanceMonitorStorageData data");
        }
    }
}
